import { createContext, useContext, useEffect, useState } from "react";
import { erpApi, ERP_TOKEN_KEY } from "@/lib/erpApi";

const ErpAuthContext = createContext(null);
export const useErpAuth = () => useContext(ErpAuthContext);

export function ErpAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, object = logged in

  useEffect(() => {
    const t = localStorage.getItem(ERP_TOKEN_KEY);
    if (!t) {
      setUser(false);
      return;
    }
    erpApi
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem(ERP_TOKEN_KEY);
        setUser(false);
      });
  }, []);

  const login = async (identifier, password) => {
    const { data } = await erpApi.post("/auth/login", { identifier, password });
    localStorage.setItem(ERP_TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(ERP_TOKEN_KEY);
    setUser(false);
  };

  const hasPerm = (perm) => {
    if (!user || user === true) return false;
    if (user.role === "admin") return true;
    return (user.permissions || []).includes(perm);
  };

  return (
    <ErpAuthContext.Provider value={{ user, login, logout, hasPerm }}>
      {children}
    </ErpAuthContext.Provider>
  );
}
